export const INSIGHTS = 'insights';
